import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=015c9d0a&scoped=true&"
import script from "./archive.vue?vue&type=script&lang=js&"
export * from "./archive.vue?vue&type=script&lang=js&"
import style0 from "./archive.vue?vue&type=style&index=0&id=015c9d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c9d0a",
  null
  
)

export default component.exports